export default __webpack_public_path__ + "static/media/avatar-placeholder.9f673c1c.svg";